import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { CommonMessage, useLocale } from '@frontend/lang';
import { ProductClient } from '@frontend/product/api';
import { defaultMapWithAttributes } from '@frontend/product/badge';
import { IProduct, ProductQueryParams } from '@frontend/product/types';
import React, { useState } from 'react';

const ID = 'product-select';
export const ProductSelectV2 = (props: ObjectSelectProps<IProduct, ProductQueryParams>) => {
    const { locale } = useLocale();
    const [v, cV] = useState<IProduct | null>(null);

    React.useEffect(() => {
        if (props.value == null) {
            cV(null);
        }
    }, [props.value]);

    return (
        <ObjectSelectInput<IProduct, ProductQueryParams>
            {...props}
            id={props.id ? `${ID}-${props.id}` : ID}
            label={props.label || CommonMessage.OBJECTS.PRODUCT.DEFAULT}
            onChange={(selected) => {
                const nextId = selected?.id ?? null;
                if (nextId !== (props.value ?? null)) {
                    props.onChange?.(nextId);
                }
                props.onChangeObject?.(selected);
                cV(selected);
            }}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value !== undefined ? props.value : v?.id}
            singleFetch={(id) =>
                ProductClient.resolveProducts([id]).then((res) => {
                    return res.results[0];
                })
            }
            fetch={(arg) => ProductClient.fetchProducts({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(prod: IProduct) => defaultMapWithAttributes(prod, locale, ['ean', 'sku'])}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'product_id',
                          fetch: (id) =>
                              ProductClient.resolveProducts([id]).then((res) => {
                                  return res.results[0];
                              })
                      }
                    : undefined
            }
        />
    );
};
